import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Label, Loader } from 'semantic-ui-react';
import useLocalFetch from '../hooks/fetch/useLocalFetch';
import PageLayout from '../layout/PageLayout';

const AccountingsPage = () => {
	const [accountings, setAccountings] = useState([]);
	const [filter, setFilter] = useState('');

	useEffect(() => {
		load({ url: 'accountings' });
	}, []);

	const [load, loading] = useLocalFetch({
		handleResult: result => {
			if (result?.success) {
				setAccountings(result.accountings);
			}
		},
	});

	const filteredAccountings = useMemo(() => {
		if (filter.trim() === '') {
			return accountings;
		} else {
			const lowerFilter = filter.toLowerCase();
			return accountings.filter(accounting =>
				accounting.label.toLowerCase().includes(lowerFilter)
			);
		}
	}, [filter, accountings]);

	return (
		<PageLayout
			className="home"
			title="Bienvenue sur MY.Compta."
			subtitle="Mes Entreprises"
			goBack
			withMenu
			home
		>
			<div className="search-bar">
				<input
					type="text"
					placeholder="Rechercher une société"
					value={filter}
					onChange={e => setFilter(e.target.value)}
					className="search-input"
				/>
				<Icon name="search" />
			</div>
			<div className="flex-grid">
				{loading ? (
					<Loader active inline="centered" />
				) : (
					filteredAccountings.map(accounting => (
						<Link to={'/accountings/' + accounting.id} className="extended">
							<Label
								key={accounting.id}
								size="big"
								className="position-relative"
							>
								{accounting.label}
							</Label>
						</Link>
					))
				)}
			</div>
		</PageLayout>
	);
};

export default AccountingsPage;
